import React from 'react';
// import { NavbarLinks } from './navbar-links';
import { NavbarMenu } from './navbar-menu';
import { Container } from 'components/atoms';

export function Navbar() {
  return (
    <div className="border-b border-border pb-5 lg:pb-0">
      <Container className="flex flex-wrap justify-between items-center gap-2 lg:px-[16px]">
        <NavbarMenu />
        {/* <NavbarLinks /> */}
      </Container>
    </div>
  );
}
